module.exports = __webpack_public_path__ + "img/v3-risk-all.0f649cb0.svg";